"use strict";

/**
 * Converts list into array
 */
module.exports = Array.from;